import { toLowerCase } from 'fp-ts/string';
import { useMemo } from 'react';
import { useAnalyticNavigation } from './analytics';
import { useBusinessIntelligenceNavigation } from './businessIngelligence';
import { useEnterpriseNavigation } from './entreprise';
import { useExportNavigation } from './exports';
import { useFinanceNavigation } from './finance';
import { useOperationNavigation } from './operations';
import { useProfilesNavigation } from './profiles';
import { useQueuesNavigation } from './queues';
import { useReservationsNavigation } from './reservations';
import { useSettingsNavigation } from './settings';
import { AssistantNavigation } from './AssistantNavigation';
import { useServicesNavigation } from './services';
import { useOtherNavigation } from './others';
import { useOnboardingAuditNavigation } from './onboardingAudit';

const useAllNavigationResults = (): AssistantNavigation[] => [
    ...useAnalyticNavigation(),
    ...useBusinessIntelligenceNavigation(),
    ...useEnterpriseNavigation(),
    ...useExportNavigation(),
    ...useFinanceNavigation(),
    ...useOnboardingAuditNavigation(),
    ...useOperationNavigation(),
    ...useProfilesNavigation(),
    ...useQueuesNavigation(),
    ...useReservationsNavigation(),
    ...useSettingsNavigation(),
    ...useServicesNavigation(),
    ...useOtherNavigation(),
];

export const useFilteredNavigationResults = (searchTerm: string): AssistantNavigation[] => {
    const list: AssistantNavigation[] = useAllNavigationResults();
    return useMemo(
        () => list.filter(({ searchValue }) => searchValue.includes(toLowerCase(searchTerm))),
        [list, searchTerm]
    );
};
